import React from 'react';
import Typography from 'fuse-ui/components/Typography';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

const styles = theme => ( {
    container: {
        alignItems: 'center',
        paddingTop: 100, //160px total from the top of the widget
        textAlign: 'center',
    },
    message: {
        maxWidth: 500,
    }
} );

const WidgetDescriptionMessage = ( { classes, dataAutomationId, message } ) => {
    return (
        <div className={classes.container} data-automation-id={dataAutomationId}>
            <Typography className={classes.message} color="textSecondary">{ message }</Typography>
        </div>
    );
};

WidgetDescriptionMessage.propTypes = {
    classes: PropTypes.object.isRequired,
    dataAutomationId: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
};

export default withStyles( styles )( WidgetDescriptionMessage );
